import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { scaVitrineId } from '../../Atoms/vtsAtoms';

const ShowVitrine = () => {
  const setVitrineId = useSetAtom(scaVitrineId);

  useEffect(() => {
    if (window) {
      //@ts-ignore
      window.showVitrine = (vitrineId: string) => {
        setVitrineId(Number(vitrineId));
      };
    }
  }, [window]);

  return null;
};

export default ShowVitrine;
